module.exports = __webpack_public_path__ + "static/media/ps.b27362c5.svg";